import OImage from 'components/reusable/OImage'
import { startCase } from 'lodash'
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import helper from 'utils/helpers'
import homeImage from 'assets/images/home.png'
import { apiGet } from 'utils/apiFetch'
import apiPath from 'utils/apiPath'
import AuthContext from 'context/AuthContext'
const CompanyDetails = ({ item }) => {
  const { t } = useTranslation()
  const [subscription, setSubscription] = useState('')
  const { config } = useContext(AuthContext)
  const getActiveSubscription = async () => {
    const path = apiPath.getActiveSubscription + '/' + item?._id
    const result = await apiGet(path)
    setSubscription(result?.data?.results)
  }
  useEffect(() => {
    getActiveSubscription()
  }, [])
  return (
    <>
      <div className='relative p-6 flex-auto'>
        <div className=' border-2 rounded-md p-5'>
          <div className='grid grid-cols-4 '>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_COMPANY_NAME')}:</strong>
              </div>
              {startCase(item?.name)}
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_COMPANY_MOBILE_NUMBER')}:</strong>
              </div>
              {item?.mobile ? `+(${item?.countryCode})${item?.mobile}` : 'N/A'}
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_COMPANY_EMAIL_ADDRESS')}:</strong>
              </div>
              {item?.email}
            </div>

            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_HEAD_OFFICE')}:</strong>
              </div>
              {startCase(item?.headOffice)}
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('AUTHORIZED_PERSON_NAME')}:</strong>
              </div>
              {startCase(item?.authorizationPersonName) || 'N/A'}
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('ORN')}:</strong>
              </div>
              {item?.orn}
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_CREATED_AT')}:</strong>
              </div>
              {helper.dateFormat(item?.createdAt)}{' '}
            </div>

            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_ACTIVE_DE_ACTIVE')}:</strong>
              </div>
              <div className='flex justify-start items-center p-4'>
                <label className='inline-flex relative items-center '>
                  <input
                    type='checkbox'
                    className='sr-only peer'
                    checked={item?.status === 'active'}
                    disabled
                  />
                  <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                </label>
              </div>
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_COMPANY_LOGO')}:</strong>
                <figure className='w-24 h-24'>
                  {/* <img src={item?.logo} alt='Company logo' /> */}
                  <OImage
                    src={item?.logo ?? homeImage}
                    fallbackUrl={homeImage}
                    className='w-full h-full bg-cover'
                    alt=''
                  />
                  {/* <img src="https://www.kindpng.com/picc/m/729-7293951_small-house-png-image-home-png-transparent-png.png" alt=''/> */}
                </figure>
              </div>
            </div>
          </div>
          <div className='mb-3'>
            <div className=''>
              <strong>{t('Bio')}:</strong>
            </div>
            {item?.bio || 'N/A'}
          </div>
          <div className='mb-5'>
            <strong>{t('O_SUBSCRIPTION_DETAILS')}</strong>
          </div>
          <div className='grid grid-cols-4 '>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_PLAN')}:</strong>
              </div>
              <div>{subscription?.subscriptionName || 'N/A'}</div>
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_PURCHASE_DATE')}:</strong>
              </div>
              <div>
                {subscription?.createdAt
                  ? helper.dateFormat(subscription?.createdAt)
                  : 'N/A'}
              </div>
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_EXPIRY_DATE')}:</strong>
              </div>
              <div>
                {subscription?.expiryDate
                  ? helper.dateFormat(subscription?.expiryDate)
                  : 'N/A'}
              </div>
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('OFFERS_VALIDITY')}:</strong>
              </div>
              <div>
                {subscription?.subscriptionMonths
                  ? subscription?.subscriptionMonths + ' ' + 'Months'
                  : 'N/A'}
              </div>
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('PRICE')}:</strong>
              </div>
              <div>
                {subscription?.subscriptionPrice
                  ? helper.priceFormat(subscription?.subscriptionPrice) +
                    ' ' +
                    config?.currency
                  : 'N/A'}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default CompanyDetails
